var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteRightNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4536 11L8.51849 7.06485C8.1605 6.70687 8.1605 6.12647 8.51849 5.76849C8.87647 5.4105 9.45687 5.4105 9.81485 5.76849L14.3982 10.3518C14.7562 10.7098 14.7562 11.2902 14.3982 11.6482L9.81485 16.2315C9.45687 16.5895 8.87647 16.5895 8.51849 16.2315C8.1605 15.8735 8.1605 15.2931 8.51849 14.9352L12.4536 11Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteRightNav);
export default __webpack_public_path__ + "static/media/whiteRightNav.c85aa17727a15951620d586ae00133ed.svg";
export { ForwardRef as ReactComponent };